import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

type Props = {
    skip: number;
    limit: number;
    search?: string | null;
    status?: string | undefined;
    start_date?: string | undefined;
    end_date?: string | undefined;
};

// API call to get all plan features
export const getAllBillings = async (skip: number, limit: number, search?: string | null, status?: string | undefined, start_date?: string | undefined, end_date?: string | undefined) => {
    let url = `/store_subscription_plan?skip=${skip}&limit=${limit}`;
    if (search) {
        url += `&search=${search}`;
    }
    if (status) {
        url += `&status=${status}`;
    }
    if (start_date) {
        url += `&start_date=${start_date}`;
    }
    if (end_date) {
        url += `&end_date=${end_date}`;
    }

    const response = await Axios.get(url);
    return response.data;
};

// React Query hook
export const useGetAllBillings = ({ skip, limit, search, status, start_date, end_date }: Props) => {
    return useQuery({
        queryKey: ["get-billing", skip, limit, search, status, start_date, end_date],
        queryFn: () => getAllBillings(skip, limit, search, status, start_date, end_date),
        staleTime: 5 * 60 * 1000, // Optional: keeps data fresh for 5 minutes
        retry: 1, // Optional: retry once on failure
    });
};
